import { render } from "./DecorationApp.vue?vue&type=template&id=d97a0e26&scoped=true"
import script from "./DecorationApp.vue?vue&type=script&lang=js"
export * from "./DecorationApp.vue?vue&type=script&lang=js"

import "./DecorationApp.vue?vue&type=style&index=0&id=d97a0e26&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d97a0e26"]])

export default __exports__